export const Spanish = {
  translation: {
    pickup: {
      expiredTitle: "Tu enlace ha caducado",
      expiredDescriptionWithDays:
        "Han pasado {{days}} días desde que se envió el enlace, por lo que tendrás que reiniciar tu inscripción. Así podremos proporcionarte la información más precisa para tus circunstancias.",
      expiredDescription:
        "Este enlace ya no es válido. Reinicia tu inscripción para que podamos proporcionarte la información más precisa para tus circunstancias.",
      newexpireDescription:
        "Deberás reiniciar tu proceso de inscripción para que podamos proporcionarte la información más precisa.",
      restart: "Reiniciar mi inscripción",
      welcomeBack: "Te damos la bienvenida de nuevo, {{name}}",
      progressSaved:
        "Ya has completado parte de tu inscripción. A continuación, continuarás con:",
      fewMoreMinutes: "Solo te llevará unos minutos más.",
      continue: "Continuar la inscripción",
      scheduledExistingAccount:
        "Tu cita de instalación ya está programada. Inicia sesión en Mi Cuenta para ver y administrar tu cita.",
      scheduledNewAccount:
        "Tu cita de instalación ya está programada. Crea tu contraseña de Mi Cuenta para ver y administrar tu cita.",
      logInToAccount: "Iniciar sesión en la cuenta",
      createAccount: "Crear una cuenta",
    },
    europe: {
      welcomeTitle: "Bienvenido a LifeSafer",
      welcomeDescription:
        "Dispositivos de bloqueo de encendido seguros y conformes, diseñados para que vuelva a la carretera.",
      "GDPR-compliant": "Conforme con el RGPD",
      Securebydesign: "Seguro por diseño",
      Discreetandeasytouse: "Discreto y fácil de usar",
      duration: "Este proceso tarda aproximadamente 5 minutos.",
      getStarted: "Comenzar",
      aboutYouTitle: "Sobre usted",
      aboutYouDescription:
        "Esto nos ayuda a confirmar que somos una buena opción y adaptar la información que compartimos. Nunca enviaremos mensajes no deseados ni compartiremos sus datos.",
      violationCountry: "País de la infracción",
      chooseCountry: "Elija un país…",
      countryRequired: "El país es obligatorio",
      registrationCountryRequired: "El país de matriculación es obligatorio",
      registrationNumberRequired: "El número de matrícula es obligatorio",
      completeRequiredFields:
        "Complete todos los campos obligatorios antes de continuar.",
      fieldRequired: "{{field}} es obligatorio",
      privacyPolicy: "Política de privacidad",
      vehicleTitle: "Información del vehículo",
      whatFeatures: "¿Qué características tiene su vehículo?",
      vehicleRegistration: "Matrícula del vehículo",
      registrationCountry: "País de matriculación",
      selectRegistrationCountry: "Seleccione un país",
      registrationNumber: "Número de matrícula",
      enterRegistrationNumber: "Ingrese el número de matrícula",
      licensePlate: "Matrícula",
      licensePlateRequired: "La matrícula es obligatoria",
      addressTitle: "Domicilio",
      scheduleTitle: "Programe su cita",
      postalCode: "Código postal",
      postalCodeRequired: "El código postal es obligatorio",
      postalCodeInvalid: "El código postal es inválido",
      scheduleDescription:
        "¿Listo para programar una cita? Llame al número de abajo y nuestro equipo le ayudará a encontrar el mejor lugar y horario.",
      callToSchedule: "Llamar para programar",
      contactConsentMessage:
        "Utilizaremos la información que proporcione en este formulario para responder a su consulta y comunicarnos con usted sobre su solicitud. Al enviar este formulario, reconoce que sus datos se procesarán de acuerdo con nuestra <privacyPolicy>Política de privacidad</privacyPolicy>.",
    },
    formattedDate: {
      intlDateTimeShort: "{{ date, short }}",
    },
    brandInfo: {
      brandName: {
        lifesafer: "LifeSafer",
        monitechnc: "Monitech",
        guardianinterlock: "Guardian Interlock",
        quickstartaz: "QuickStart",
      },
      brandPhone: {
        lifesafer: "(855) 221-0171", //special phone number for LS installations
        monitechnc: "(800) 521-4246",
        guardianinterlock: "(800) 499-0994",
        quickstartaz: "(888) 717-8278",
      },
      brandPhoneHref: {
        lifesafer: "tel:+1-855-221-0171",
        monitechnc: "tel:+1-800-521-4246",
        guardianinterlock: "tel:+1-800-499-0994",
        quickstartaz: "tel:+1-888-717-8278",
      },
    },
    policies: {
      language: "Idioma",
      callUs: "Llame ",
      termsofUseLabel: "Condiciones",
      privacyLabel: "Privacidad",
      cookiesLabel: "Cookies",
      qualityLabel: "Calidad",
      copyrightLabel: "Derechos de autor",
      helpPopupTitle: "Ayudar",
      helpPopupPart1:
        "Deje que nuestro equipo de soporte capacitado lo ayude con esta inscripción.",
      helpPopupPart2: "Su ID de sesión: ",
      helpPopupPart3: "Llame o haga clic",
      helpPopupPart4: "¡Importante!",
      helpPopupPart5:
        "¿Cometí un error? ¿Escribiste mal algo? ¡No se preocupe, podrá actualizar toda esta información al final de la inscripción en nuestro Portal de Clientes!",
      callMonitech:
        "Lamentablemente no estamos en este estado, pero ¡buenas noticias! Nuestro socio Monitech sí presta servicios en este estado. No dude en contactar con Monitech al (800) 521-4246.",
      notAvailable: [
        "Lamentablemente ",
        " no presta servicio en este estado por el momento. Si tiene alguna pregunta, no dude en llamarnos al, ",
        ".",
      ],
      countyQuestionable:
        "Para este condado necesitaremos que se comunique con nosotros para que podamos ayudarlo con la inscripción, (800) 634-3077.",
    },
    intro: {
      headerSlogan: "Estamos comprometidos con su éxito",
      mailLoader: "Estamos buscando tu información...",
      fantastic: "¡Fantástico! ",
      step1: "¿Cuál es el código de inscripción que se le proporciona?",
      invalidCode:
        "Hmm... Algo no parece estar bien con ese código de inscripción. ¿Qué tal si intenta ingresarlo nuevamente? De lo contrario, contáctenos al ",
      lockoutPart1:
        "Vamos a conseguirle ayuda, ¡su código simplemente no funciona! ",
      lockoutPart2: "Comuníquese con nosotros al ",
      lockoutPart3:
        " para hablar con nuestro experto equipo de servicio 24 horas al día, 7 días a la semana.",
      step1half: [
        "¿Por favor, dígame en qué estado lo condenaron o se ofrecieron como voluntario para tener un dispositivo ",
        "?",
      ],
      step2Part1: [
        "Hola, mi nombre es ",
        " y bienvenido al chat de inscripción de ",
        ". Fuiste referido por ",
      ],
      step2Part2: [", quien se asoció con ", " para ofrecerle "],
      step2Part2Add: " una manera rápida y fácil de inscribirse",
      step2Part3: ". ¡Haz clic en el botón de abajo para empezar!",
      step2ButtonLabel: "Empezar",
      step2halfPart1:
        "Hágame saber qué tipo de dispositivo necesita. Haga clic ",
      step2halfPart2:
        " para obtener información rápida si no sabe qué dispositivo necesita.",
      step2halfButtonLabel: "aquí",
      step3:
        "¿Cuál es su dirección de correo electrónico o la mejor dirección de correo electrónico para usted? ¿Cuál es su mejor número de contacto con código de área? ",
      step3Part2: "¿Inscripción iniciada previamente?",
      step3half:
        "Encontramos su correo electrónico en nuestros archivos, por lo que le hemos enviado un código de verificación para asegurarnos de que sea usted. Este código caducará en 10 minutos, haga clic en el botón de abajo para ingresar el código.",
      step3sixth:
        "Encontramos su correo electrónico en nuestros archivos, ¿cómo le gustaría recibir su código de verificación?",
      step3seventh:
        "Ingrese el código de verificación proporcionado y haga clic en el botón Continuar.",
      step3seventhExpired:
        "¡Oh, no! Su código de verificación ha caducado, haga clic en el botón de abajo para recibir un nuevo código.",
      step3seventhInvalid:
        "Hmm ... Algo no parece correcto con ese código de verificación. ¿Qué tal si intenta ingresarlo nuevamente?",
      optInTitle: "RECIBE ACTUALIZACIONES DE INSCRIPCIÓN EN TU TELÉFONO",
      optInBodyPart1:
        "Agilice su proceso de instalación. Le enviaremos actualizaciones por mensaje de texto para ayudarlo a completar su inscripción y mantenerse actualizado con su cuenta.",
      optInBodyPart2: [
        "Al presionar 'Recibir actualizaciones de texto', doy mi consentimiento (y proporciono mi firma digital) para recibir mensajes de texto promocionales automatizados de ",
        " sobre mi inscripción (también se pueden enviar ofertas especiales y cupones) al número de teléfono móvil proporcionado.",
      ],
      optInBodyPart3:
        "No se requiere consentimiento/condición de compra. Se aplican tarifas de mensajes/datos. Responda STOP para optar por no participar (se enviará una confirmación). Responda AYUDA para obtener ayuda. Consulte nuestros Términos de uso y lea nuestra Política de privacidad.",
      optInConfirm: "Recibir actualizaciones de texto",
      optInCancel: "No, Gracias",
      step4:
        "¿Le gustaría utilizar el Cargador Rápido de ID o ingresar manualmente su información? Tenga en cuenta que para el Cargador Rápido de ID necesitará su identificación estatal disponible para una foto.",
      step4halfPart1: "Cargue una foto o tómela con su cámara de la ",
      step4halfPart2: "parte posterior de su identificación estatal",
      step4halfPart3: ". También puede ingresarlo manualmente haciendo clic",
      badUpload:
        "Hmm ... No pudimos extraer la información de esa imagen. ¿Qué tal si prueba una nueva imagen? Asegúrese de que esté en el reverso de su identificación estatal; de lo contrario, puede ingresarla fácilmente de forma manual haciendo clic",
      badUploadPart2:
        "Sugerencia útil: siempre puede tomar una foto fuera de este sitio web, luego use nuestra sección de carga y cargue la foto allí.",
      badPhotoFile:
        "Desafortunadamente, este no es un tipo de archivo de foto, cargue otro archivo.",
      step5:
        "¿Cuál es su nombre legal y apellido legal, tal como aparece en su identificación estatal?",
      codeInputLabel: "Código de Inscripción",
      codeInputRequired: "Se requiere el código de inscripción.",
      codeInputInvalid: "Código de inscripción no válido.",
      noEnrollmentCode: "¿Sin código de inscripción?",
      IIDButtonLabel: "Dispositivo de Bloqueo de Encendido",
      PAMButtonLabel: "Monitor de Alcohol Portátil",
      SpeedButtonLabel: "Dispositivo de velocidad",
      devicePopupTitle: " Información del Dispositivo",
      devicePopupPart1:
        "Un pequeño alcoholímetro de mano para automóvil que mide la cantidad de alcohol en el aliento del usuario. Instalar uno es un requisito común después de una infracción por conducir en estado de ebriedad (DUI, DWI, DUI, OWI u OVI).",
      devicePopupPart2:
        "Un pequeño dispositivo portátil de alcoholemia que mide la cantidad de alcohol en el aliento del usuario. Emitido comúnmente para monitorear a un usuario mientras está en casa.",
      devicePopupButtonLabel: "Cerca",
      startedEnrollmentBody:
        "¡No se preocupe, lo tenemos cubierto! ¡Simplemente ingrese su dirección de correo electrónico que usó anteriormente y su número de teléfono y lo llevaremos de regreso a donde estaba en la inscripción!",
      startedEnrollmentBodyPart2:
        "¿Necesitas ayuda? Nos encantaría hablar llamar o hacer clic ",
      emailLabel: "Correo Electrónico",
      textLabel: "Mensaje de Texto",
      textMessageFail:
        "Lamentablemente, el mensaje de texto no se pudo enviar, por lo que le enviamos un correo electrónico.",
      tooManyAttempts:
        "Lamentablemente, ha alcanzado nuestro límite de intentos fallidos de código de verificación.",
      newCodeLabel: "Nuevo Código de Verificación",
      IDUpload: "Carga Rápida de ID",
      ManualEntry: "Entrada Manual",
      firstNameLabel: "Primer Nombre Legal",
      lastNameLabel: "Apellido Legal",
      firstNameRequired: "Se requiere el Primer Nombre.",
      lastNameRequired: "Se requiere Apellido.",
      nameError: "Solo cartas por favor.",
      lastNameError: "El apellido no es válido.",
      emailAddressLabel: "Dirección de Correo Electrónico",
      phoneTypeLabel: "Tipo de Telefono",
      phoneNumberLabel: "Número de Teléfono",
      emailAddressRequired: "Correo electronico es requerido.",
      phoneNumberRequired: "Se requiere el número de teléfono.",
      emailAddressError: "Dirección de correo electrónico inválida.",
      phoneNumberError: "Se requiere un número de teléfono válido.",
      alreadyRegistered: [
        "Esta dirección de correo electrónico no se puede utilizar para la inscripción de clientes debido a que está adjunta a otro sitio de ",
        ".",
      ],
      toVerification: "Ingrese el código de verificación",
      resetCodeInputLabel: "Código de Verificación",
      resetCodeInputRequired: "Se necesita un código de verificación.",
      resetCodeInputInvalid: "Código de verificación invalido.",
      photoUpload: "Tomar Foto",
      fileUpload: "Subir Foto",
      instructions: "Instrucciones",
      photoInstructions:
        "Al tomar la fotografía, asegúrese de que la identificación esté lo más centrada posible. Cuando esté listo, haga clic en el botón de abajo para activar su cámara, es posible que deba permitirnos este acceso (debería aparecer una ventana emergente).",
      computerCamInfo:
        "Nota: Es posible que muchas cámaras web portátiles integradas no produzcan una imagen de calidad suficiente para este proceso de carga.",
      fileInstructions:
        "Al tomar la fotografía, asegúrese de que la identificación esté lo más centrada posible. Luego haga clic en el botón de carga y elija su imagen. Formatos aceptados: .png, .jpg, .jpeg, .heic",
      retake: "Retomar Foto",
      upload: "Subir",
      chooseFile: "Elija el Archivo",
      newFile: "Archivo Nuevo",
      example: "Ejemplo",
      communicationsDisclaimer: [
        "* Al enviar este formulario, usted acepta y da su consentimiento para que",
        " y sus afiliados utilicen tecnología automatizada, incluidos correos electrónicos, llamadas y mensajes pregrabados, para contactarlo con la información proporcionada. No se requiere compra.",
      ],
      verificationCode: "Código de verificación",
      verificationCodeTitle: "Verificar número de teléfono",
      verificationCodeDescription:
        "El correo electrónico ingresado ya existe en nuestro sistema con un número de teléfono diferente. Para continuar usando el correo electrónico ingresado, verifique su teléfono con el código que le enviamos por mensaje de texto.",
      submitVerificationCode: "Ingrese el código",
      verificationCodeRequired: "Código de verificación requerido.",
      verificationCodeInvalid: "Código de verificación no válido",
      verificationCodeIncorrect:
        "El código de verificación era incorrecto. Verifique dos veces e ingrese nuevamente.",
      verificationCodeExpired: "Código de verificación expirado.",
      phoneEmailTitle: "Es posible que ya tenga una cuenta",
      phoneEmailMessage: [
        "Encontramos una cuenta existente con el nombre y el número de teléfono que ingresó",
        "¿Le gustaría continuar usando el correo electrónico que ya está en nuestro sistema o el que acaba de ingresar?",
      ],
      useExistingEmail: "Usar correo electrónico existente",
      useNewEmail: "Usar nuevo correo electrónico",
      errorSendingText: "Error al enviar texto.",
      contactUs: "Contacta con nosotros",
      contactUsMessage:
        "No tenemos un teléfono celular registrado para usted. Por favor llámenos al (800) 634-3077",
      formLeadTextMessage: [
        "¡Bienvenido de nuevo! Parece que ya ha comenzado el proceso de programación de la instalación. Para verificar su información, le hemos enviado un código a través de mensaje de texto a",
        ". Una vez verificado, puede continuar donde lo dejó.",
      ],
      firstNameInvalid: "El nombre no es válido.",
    },
    error: {
      pickBackUpTokenError: [
        "Error al validar tu token. Está caducado o no es válido.",
        "Por favor, póngase en contacto con su proveedor de servicios.",
      ],
      botMessagePart1:
        "Bueno, esto es incómodo, ¡¿creemos que podrías ser un bot como yo?!",
      botMessagePart2:
        "¡Comuníquese con nuestro equipo de soporte experto para que lo atiendan!",
      botCallUsButton: "Llámanos ",
      botStartOverButton: "Comenzar de Nuevo",
      chatMessage:
        "Bueno, esto es incómodo y muy vergonzoso. Parece que mis cables se cruzaron en algún lugar del camino. Que te gustaría hacer?",
      honeyPotError: "Algo salió mal, por favor contáctenos para ayudarle.",
      noCountyConfigured: "No hay ningún condado configurado para",
    },
    body: {
      startQuestion: "Solo unas pocas preguntas más...",
      dobQuestion: "¿Cuál es su fecha de nacimiento?",
      dobLabel: "Fecha de Nacimiento",
      dobIssue:
        "Hmm, algo salió mal en mi cableado, ¡ingrese su fecha de nacimiento una vez más por mí!",
      dobRequired: "Se requiere la fecha de nacimiento.",
      driverAgeLabel: "Edad del conductor",
      driverAgePlaceholder: "Seleccione una edad",
      driverAgeRequired: "Se requiere la edad del conductor.",
      dobInvalid: "Formato de fecha no válido.",
      dobMin: "La fecha está por debajo de la fecha mínima permitida.",
      dobMax: "La fecha está por encima de la fecha máxima permitida.",
      dateFormat: "Formato: mm/dd/yyyy",
      happyBDayAddressQuestion:
        "¡Feliz cumpleaños! ¿Cual es la dirección de tu casa? Para completar este paso, comience a escribir en la primera línea y elija su dirección; si no puede encontrar su dirección, ingrese y seleccione su ciudad y estado.",
      homeAddressQuestion:
        "¿Cual es la dirección de tu casa? Para completar este paso, comience a escribir en la primera línea y elija su dirección; si no puede encontrar su dirección, ingrese y seleccione su ciudad y estado.",
      homeAddr1Label: "Dirección Línea 1",
      homeAddr2Label: "Dirección Línea 2",
      homeAddrRequired: "Se requiere la dirección de casa.",
      enterHomeAddress: "Ingrese la dirección de su casa",
      licensePlateEntry: "Entrada de matrícula",
      vehicleInfoEntry: "Entrada de información del vehículo",
      homeAddrDirections:
        "Deberá seleccionar una dirección de la función de autocompletar. Si no encuentra su dirección, ingrese su ciudad y estado y seleccione.",
      ccsLabel: "Ciudad, Condado, Estado",
      ccsPlaceholder: "¡Esto se completará por ti!",
      cityLabel: "Ciudad",
      city: "Ciudad",
      province: "Código de provincia",
      country: "País",
      cityRequired: "Se requiere ciudad.",
      countyLabel: "Condado",
      countyPlaceholder: "Seleccione un Condado",
      countyRequired: "Se requiere el condado.",
      stateLabel: "Estado",
      statePlaceholder: "Selecciona un Estado",
      stateRequired: "Se requiere el estado.",
      cCStateRequired:
        "Se requiere estado. Ingrese una dirección válida o seleccione una de la lista desplegable Línea de dirección 1.",
      cantFindState:
        "¿No encuentra el estado que busca? Comuníquese con nuestro equipo de soporte para que se comunique con uno de nuestros socios que presta servicios en su estado. Llame o haga clic en el botón de abajo.",
      zipLabel: "Código postal",
      zipRequired: "Se requiere el código postal.",
      zipValid: "Un código postal válido debe tener 5 dígitos de longitud.",
      addressIssue:
        "Hmm, algo salió mal en mi cableado, ¡ingrese la dirección de su casa una vez más por mí!",
      IDQuestion:
        "Genial, ingrese la información de su identificación estatal.",
      IDNumberLabel: "Número de identificación",
      IDNumberRequired: "Se requiere un número de identificación.",
      expDateLabel: "Fecha de Caducidad",
      expDateValid: "Formato de fecha no válido.",
      expDateMin: "La fecha está por debajo de la fecha mínima permitida.",
      expDateRequired: "Se requiere fecha de vencimiento.",
      NoID: "No tengo una identificación en este momento, no hay problema, entendemos que esto puede ser parte de su proceso local. Simplemente seleccione el estado en el que tendrá una identificación, ingrese su fecha de nacimiento y haga clic en el botón Continuar.",
      NoIDInfoLink:
        "¿No tiene una identificación en este momento? Haga clic en",
      IDInfoLink: "¿Identificación estatal suspendida o revocada? Haz clic ",
      IDInfoTitle: "Información de identificación estatal",
      IDInfoBody:
        "No tienes una identificación en este momento, está bien. Entendemos que esto puede ser parte de tu proceso local. Solo selecciona el estado en el que tendrás una identificación y haz clic en el botón continuar.",
      IDNotEntered:
        "No tengo mi información de identificación en este momento.",
      IDIssue:
        "Hmm, algo salió mal en mi cableado, por favor ingresa la información de tu identificación estatal una vez más por mí.",
      VINQuestion:
        "¡Las últimas piezas de información que necesito y, por supuesto, guardé las más difíciles para el final! ¿Cuál es el número de identificación de su vehículo? Si no tiene esta información a mano en este momento, haga clic en el botón rojo para omitir.",
      VINLabel: "VIN",
      VINRequired: "Se requiere VIN.",
      VINValid: "Se requiere un VIN válido.",
      VINLength: "El VIN debe tener 16 o 17 caracteres de longitud.",
      VINConfirmLabel: "Confirmar VIN",
      VINConfirmRequired: "Se requiere confirmación de VIN.",
      VINConfirmMatch: "Los VIN deben coincidir.",
      VINInfoLinkPart1: "Haga clic ",
      VINInfoLinkPart2:
        " para obtener información rápida sobre el número de identificación de su vehículo (VIN).",
      VINInfoLink: "aquí",
      VINInfoTitle: "Información VIN",
      VINInfoHeader1: "Número de Identificación del Vehículo (VIN)",
      VINInfoHeader2: "¿Dónde encuentro mi VIN?",
      VINInfoPart1:
        "Un código de identidad de 16 o 17 caracteres compuesto por números y letras que identifica su vehículo.",
      VINInfoPart2:
        "Su VIN estará ubicado en el tablero de su vehículo visible a través del parabrisas o se puede encontrar en la documentación de registro de su vehículo.",
      VINPopupButtonLabel: "Cerca",
      VINYearLabel: "Año: ",
      VINMakeLabel: "\nMarca: ",
      VINModelLabel: "\nModelo: ",
      VINNotEntered: "No tengo la información de mi VIN en este momento.",
      VINIssue:
        "Hmm, algo salió mal en mi cableado, ¡ingrese su VIN una vez más por mí! Si no lo tiene, haga clic en el botón rojo para omitir.",
      multiVehicleQuestion:
        "Parece que tiene un vehículo en nuestro sistema, ¿podría decirme cuál usar?",
      multiVehicleNew: "Vehículo Nuevo",
      multiVehicleIssue:
        "Hmm, algo salió mal en mi cableado, selecciona una vez más para mí.",
      licensePlateQuestion:
        "¿Cuál es el año, la marca y el modelo del vehículo?",
      licensePlateVerification:
        "¿Sigue siendo este el año, marca y modelo de su vehículo?",
      licPlateLabel: "Numero de Licencia",
      licPlateRequired: "Se requiere el número de placa.",
      licPlateNotEntered:
        "No tengo la información de mi matrícula en este momento.",
      licPlateIssue:
        "Hmm, algo salió mal en mi cableado, ingrese el número de placa de su vehículo y el estado de emisión una vez más. Si no lo tiene, haga clic en el botón rojo para omitir.",
      vehYearLabel: "Año del Vehículo",
      vehYearPlaceholder: "Seleccione un año",
      vehYearRequired: "Se requiere el año del vehículo.",
      vehMakeLabel: "Marca del Vehículo",
      selectVehYearLabel: "Seleccione un Año de Vehículo",
      selectEngineTypeLabel: "Seleccione un Tipo de Motor",
      vehMakePlaceholder: "Seleccione una Marca",
      vehMakeRequired: "Se requiere la marca del vehículo.",
      vehModelLabel: "Modelo de Vehículo",
      vehModelPlaceholder: "Seleccione un modelo",
      vehModelRequired: "Se requiere modelo de vehículo.",
      programTypeQuestion:
        "Últimos datos que necesito. Seleccione su tipo de programa.",
      ProgTypeInfoLinkPart2:
        " para obtener información rápida sobre los Tipos de Programas.",
      ProgTypeInfoTitle: "Tipos de Programas",
      AdminDescription:
        "Este tipo de programa generalmente lo asigna la Administración de Vehículos Motorizados.",
      CourtOrderDescription:
        "El tribunal ha ordenado que le instalen un dispositivo.",
      VoluntaryDescription:
        "Ofrecerse como voluntario para instalar un dispositivo es una excelente manera de protegerse a sí mismo y a los demás.",
      PreTrialDescription:
        "Este tipo de programa generalmente significa que es posible que aún no haya ido a la corte o haya sido sentenciado.",
      ProbationDescription:
        "El tribunal ha ordenado que se le instale un dispositivo porque ha sido condenado en 1 o más casos anteriores.",
      adminButtonLabel: "Administrativa",
      courtButtonLabel: "Mandato Judicial",
      voluntaryButtonLabel: "Voluntaria",
      preTrialButtonLabel: "Antes del Juicio",
      probationButtonLabel: "Libertad Condicional",
      programTypeIssue:
        "Hmm, algo salió mal en mi cableado, ¡selecciona tu tipo de programa una vez más por mí!",
      deviceLengthQuestion: "¿Cuánto tiempo necesitará su dispositivo?",
      deviceLengthMonths: "Meses",
      deviceLengthIssue:
        "Hmm, algo salió mal en mi cableado. ¡Por favor, hágame saber cuánto tiempo necesitará su dispositivo una vez más!",
      lossProtectionQuestion:
        "¿Le gustaría incluir un plan de protección contra pérdidas para su dispositivo?",
      lossProtectionInfoLinkPart2:
        " para obtener información rápida sobre el Plan de protección contra pérdidas.",
      lossProtectionInfoTitle: "Plan de protección contra pérdidas",
      lossProtectionInfoPart1: [
        "Los dispositivos de monitoreo ",
        " no son baratos y no nos gustaría verlo atascado con la factura si algo sucediera. El Plan de protección contra pérdidas ",
        " evita este riesgo necesario de no tener protección contra accidentes ocasionales, ¡le recomendamos encarecidamente que proteja su dispositivo!",
      ],
      lossProtection: "Protección contra pérdidas",
      noProtection: "Sin protección",
      lossProtectionIssue:
        "Hmm, algo salió mal en mi cableado, ¡selecciona tu protección contra pérdidas una vez más por mí!",
    },
    outro: {
      step1: "¡Vaya, lo logramos! Ahora programemos su cita de instalación ",
      step1IID: "para que podamos volver a la carretera.",
      step1PAM: "para que pueda obtener su PAM rápidamente.",
      step1CallNow: "Programe en línea o llámenos para programar.",
      scheduleOnlineButton: "Programar en Línea",
      callNowButton: "Llame ahore para Programar",
      step2:
        "Fantástico, ¡hagamos esto! Esperamos poder hablar con usted, haga clic o llame al número de teléfono a continuación para comunicarse con nosotros ahora.",
      step2one:
        "Hmm ... No puedo encontrar un vehículo para usted en nuestro sistema, ¡así que hagamos esto con nuestro equipo de soporte experto! Haga clic o llame al número de teléfono a continuación para comunicarse con nosotros ahora.",
      step3: [
        "Una pregunta rápida antes de programar su cita, ¿en qué vehículo está instalando el IID ",
        "?",
      ],
      enterTextBox: "Ingrese el código postal o ciudad, estado",
      search: "Buscar...",
      noLocations:
        "No hay ubicaciones en el área seleccionada, llame o haga clic en el número a continuación para que podamos ayudarlo con su cita.",
      searchIssue:
        "No se puede localizar esta combinación de código postal o ciudad, estado. Inténtalo de nuevo.",
      searchResults: "Resultados de la Búsqueda",
      mapInfo: "Información del Mapa",
      partnerLoc: "Ubicación preferida",
      sameDayLoc: "Ubicación el mismo día",
      standardLoc: "Ubicación estándar",
      select: "Seleccione",
      selectedLocation: "Ubicación Seleccionada",
      discountMessagePart1:
        "- Reserva ahora en un día en el que este icono esté",
      discountMessagePart2:
        "se muestra y ¡obtenga $25 de descuento adicional!*",
      discountDisclaimer: [
        "* Al reservar su cita en estas fechas, recibirá un crédito adicional de $25 que se aplicará a las tarifas de ",
        ". El descuento no se puede aplicar a los cargos de mano de obra.",
      ],
      noAppointmentsAvail:
        "Actualmente no hay citas disponibles para esta ubicación.",
      backToLocations: "Volver a Ubicaciones",
      backToCalendar: "Volver al Calendario",
      date: "Fecha",
      time: "Tiempo",
      confirmation: "Confirmación",
      yesButton: "Sí",
      noTimesAvailable: "No hay horarios disponibles.",
      aptSchedPart1: "Ha seleccionado hacer \n una cita en: \n",
      aptSchedPart2: " en ",
      aptSchedPart3:
        "\n para un Servicio de Instalación \n en la siguiente ubicación: \n",
      apptSaveSuccess: "Cita guardada.",
      apptSaveFailure: "No se pudo guardar la cita, intentemos una vez más.",
      step4:
        "¡¡Gracias por inscribirte conmigo !! Este es el último paso antes de que lo transfiera a nuestro Portal del cliente, por favor cree su contraseña del Portal del Cliente.",
      password: "Contraseña",
      confirmPassword: "Confirmar Contraseña",
      passwordWarning:
        "* Su contraseña debe tener un mínimo de 8 caracteres y contener al menos 1 letra mayúscula, 1 letra minúscula, 1 número y 1 carácter especial.",
      passwordRequired: "Se requiere contraseña.",
      passwordValid:
        "La contraseña debe tener entre 8 y 24 caracteres, contener al menos 1 letra mayúscula, 1 letra minúscula, 1 número y 1 carácter especial.",
      confirmPasswordRequired: "Se requiere confirmación de contraseña.",
      matchPassword: "La contraseña debe coincidir.",
      step5: [
        "¡Parece que ya tiene una cita o tiene instalado un dispositivo ",
        "",
      ],
      step5Part1: {
        lifesafer:
          "! Haga clic en el botón de abajo para iniciar sesión en el Portal del Cliente.",
        monitechnc:
          "Haga clic en el botón de abajo para ponerse en contacto con nosotros acerca de su cuenta.",
        guardianinterlock:
          "Haga clic en el botón de abajo para ponerse en contacto con nosotros acerca de su cuenta.",
        quickstartaz:
          "Haga clic en el botón de abajo para ponerse en contacto con nosotros acerca de su cuenta.",
      },
      step5Part2: {
        lifesafer:
          "Dentro del portal puede ver la información de su dispositivo; ver, programar, actualizar y cancelar citas; ver su información de facturación y realizar pagos; y revisar y actualizar su información personal.",
        monitechnc: "",
        guardianinterlock: "",
        quickstartaz: "",
      },
      toClientPortal: "Portal del Cliente",
      getHelpTitle: "¡Habla con los expertos!",
      getHelpPart1:
        "¿La ubicación o el tiempo en línea no es lo que necesita? ¡Deje que nuestro equipo de expertos 24/7 lo ayude!",
      thankYou: [
        "¡Gracias por inscribirte con ",
        "! Esperamos verlo en su próxima cita de instalación.",
      ],
      thankYou1:
        "Si tiene alguna pregunta, no dude en comunicarse con nosotros en ",
    },
    quickLink: {
      header: "Referencia del cliente",
      firstName: "Primer nombre",
      firstNameError: "Primer nombre requerido.",
      lastName: "Apellido",
      lastNameError: "Apellido Obligatorio.",
      cellPhoneNumber: "Número Celular",
      cellPhoneError: "Número de teléfono válido requerido",
      sendQuickLink: "Enviar",
      sendAnother: "Le gustaría enviar otro?",
      confirmNewQuickLink: "Sí",
      enrollmentCodeInvalid: [
        "El código de inscripción proporcionado: ",
        " no es válido.",
        "Póngase en contacto con su representante para obtener ayuda..",
      ],
      referralSentToast: "Referencia enviada!",
      clientExists: "El cliente existe.",
      errorCreatingReferral: "Error al crear referencia.",
    },
    formLead: {
      queryStringError:
        "El enlace proporcionado no contenía la información requerida.",
      header: [
        "Gracias por comunicarse con LifeSafer®.",
        "Un experto se pondrá en contacto en breve.",
      ],
      subHeader: [
        "¿Listo para programar la instalación?",
        "Evite la espera y programe en línea en 5 minutos o menos.",
      ],
      previousPage: "Volver a la página anterior",
      nextSteps: "Próximos pasos",
      scheduleInstallation: "Programar instalación",
      stateQuestion:
        "¿En qué estado fue condenado o se ofreció como voluntario para tener un dispositivo LifeSafer?",
      needAssistance: "¿Necesita ayuda? Llamenos al ",
      learnMore: "Más información sobre Monitech",
      // New
      greeting: "Gracias por contactarnos",
      message: "¡Espera un momento! Nos comunicaremos contigo en breve.",
      save: "AHORRA TIEMPO Y DINERO",
      continue: "Continúa en línea y ahorra $25 en tu primer pago",
      claim: "Reclama mi oferta de $25",
      back: "< Volver a la página de inicio",
    },
    steps: {
      vehiclePresentMessage:
        "Hemos encontrado un vehículo previamente ingresado para usted en nuestro sistema, ¿cuál le gustaría utilizar?",
      newVehicle: "Vehículo Nuevo",
      pushStartMessage: `Presione un botón de "inicio" dentro del vehículo`,
      remoteStartMessage: `Arrancar un vehículo usando un llavero o una aplicación`,
      pushStartLevel: `Arranque sin llave "Push"`,
      remoteStart: "Inicio Remoto",
      engType: "Tipo de Motor",
      engTypeRequired: "Tipo de motor requerido",
      select: "Seleccionar",
      back: "Previo",
      story: "Historia",
      continue: "Continuar",
      send: "Enviar",
      welcome: "Bienvenido",
      myAccount: "Mi Cuenta",
      start: "Comenzar",
      aboutYou: "Acerca de Ti",
      startMyQuote: "Iniciar Mi Cotización",
      stateInformation: "Información Estatal",
      stateInfo: "Información del estado",
      vehicleInfo: "Información del vehículo",
      yourVehicle: "Su Vehículo",
      buildMyQuote: "Construir Mi Cotización",
      twentyfiveoff: "$25 de descuento por tiempo limitado",
      pamShort: "PAM",
      isaShort: "ISA",
      iidShort: "IID",
      devices: "Dispositivos",
      scheduleInstallation: "Instalación Programada",
      sendEmailTo: "Enviar Correo Electrónico a",
      appointmentMessage:
        "Su equipo White Glove está listo para ayudarlo o inicie sesión en el sitio Mi cuenta para administrar su cuenta.",
      installedMessage:
        "¡Buenas noticias! Parece que ya tienes instalado un dispositivo Lifesafer. Haz clic en el botón de abajo para iniciar sesión en Mi Cuenta y administrarla.",
      buildQuoteSuccess: "¡Éxito! Estamos creando tu cotización ahora...",
      verificationCode: "Código de Verificación",
      lossProtectionPlan: "Plan de Protección de Pérdidas",
      buildCodeMessage1: "Aguanta, esto no llevará mucho tiempo.",
      buildCodeMessage2: "Espere nuestra llamada",
      buildCodeMessage3:
        "{{ ContactPreference }} en los próximos 5 minutos o le daremos $25 de descuento en su instalación y nos aseguraremos de que obtenga el precio más bajo disponible.",
      buildCodeMessage4:
        "Si tiene alguna pregunta mientras tanto, no dude en contactarnos – estamos aquí para ayudarle.",
      lppMessage:
        "Los dispositivos de monitoreo LifeSafer no son económicos y no queremos que tenga que pagar la factura si algo sucede. El Plan de Protección contra Pérdidas de LifeSafer evita este riesgo innecesario de no tener protección contra accidentes ocasionales. Le recomendamos encarecidamente que proteja su dispositivo.",
      stateMessage:
        "Esto ayuda a nuestros expertos a asegurarse de que complete su programa lo más rápido y económico posible.",
      welcomeMessage:
        "Revisaremos su cotización personalizada de manera rápida, segura y con el precio más bajo disponible.",
      aboutMessage:
        "Esto nos ayuda a asegurarnos de que somos una buena opción y podamos brindarle la información correcta. Nunca le enviaremos spam ni compartiremos sus datos: su privacidad es importante para nosotros.",
      welcomeBackMsg: "Bienvenido de nuevo, se le ha enviado un",
      enterCode: "Ingrese el código a continuación.",
      noReceive: "¿No recibió su código?",
      textCharges:
        "Dependiendo de su proveedor, pueden aplicarse cargos por mensajes de texto.",
      verificationEmail: "correo electrónico de verificación",
      verificationRequired: "Se requiere código de verificación",
      sendTextMessage: "Enviar Mensaje de Texto",
      resendVerification:
        " Reenvíe el código de verificación o no dude en llamarnos, estamos listos para ayudarle.",
      pickAStoryMessage:
        "Para garantizar la mejor experiencia posible de inscripción, ¿Qué es lo más importante para usted?",
      scheduleNow: "Agenda Ahora",
      findInstallationLocation: "Buscar Ubicación de Instalación",
      learnMore: "Más Información",
      success: "Éxito",
      personalizedQuote: "Cotización Personalizada",
      welcomeBack:
        "¡Bienvenido de nuevo {{FirstName}}! Nuestro equipo de soporte dedicado y capacitado está listo para ayudarlo con su inscripción. Siéntase libre de continuar con su inscripción o llámenos ahora.",
      contactMessage:
        "Nos gustaría hablar con usted sobre cómo Lifesafer puede ayudarle. Llame ahora para hablar con el especialista de su estado.",
      preferContacted: "¿Cómo prefiere que lo contactemos?",
      emailPlaceholder: "yourname@youremail.com",
      phoneCall: "Llamada Telefónica",
      textMessage: "Mensaje de Texto",
      contactConsentMessage:
        "* Al enviar este formulario, usted acepta recibir mensajes de texto de servicio al cliente y de marketing (por ejemplo, promociones, recordatorios de citas) de LifeSafer al número proporcionado, incluidos mensajes enviados mediante tecnología automatizada. Su consentimiento no es condición para la compra. Pueden aplicarse tarifas por mensajes y datos. La frecuencia de mensajes varía. Puede darse de baja en cualquier momento respondiendo con la palabra STOP o haciendo clic en el enlace de cancelación de suscripción (cuando esté disponible).",
      cellNumber: "Número de Celular",
      violationState: "Estado de Infracción",
      violationCounty: "Condado de Infracción",
      countyRequired: "El condado es obligatorio",
      violationStateRequired: "El estado de la infracción es obligatorio",
      violationCountyRequired: "El condado de la infracción es obligatorio",
      whoIsRequiringDevice: "Quién necesita el dispositivo",
      whoIsRequiringDevicePlaceholder: "Seleccione Requerido por",
      whoIsRequiringDeviceRequired: "Este campo es obligatorio",
      deviceNeeded: "Dispositivo Necesario",
      deviceNeededRequired: "Se requiere el dispositivo necesario",
      deviceRequired: "El dispositivo es obligatorio",
      deviceNeededPlaceholder: "Seleccione un Dispositivo",
      deviceNeededQuestion: "Durante cuánto tiempo necesitará el dispositivo",
      deviceNeededQuestionRequired: "Este campo es obligatorio",
      iid: "Dispositivo de Bloqueo de Encendido (IID)",
      iidDescription:
        "Un pequeño dispositivo portátil que se conecta al sistema de encendido del vehículo y mide la cantidad de alcohol en el aliento del usuario. Su instalación es un requisito común tras una infracción por conducir ebrio (DUI, DWI, OWI, or OVI).",
      pam: "Monitor de Alcohol Portátil (PAM)",
      pamDescription:
        " Un alcoholímetro pequeño, portátil y con mango que mide la cantidad de alcohol en el aliento. Se utiliza comúnmente para monitorear al usuario en casa.",
      isa: "Asistencia de Velocidad Inteligente (ISA)",
      isaDescription:
        " Una solución que ayuda a controlar su velocidad manteniendo un límite de velocidad máxima fijo para garantizar que esté practicando hábitos de conducción seguros.",
      stateId: "Identificación Estatal",
      identificationNumberRequired: "Se requiere número de identificación",
      identificationNumberSelect: "Seleccione un número de identificación",
      comingSoon: "Muy pronto",
      idInfoDescription: `¿No tienes identificación ahora? No hay problema, entendemos que esto puede ser parte del proceso local. Solo selecciona el estado donde tendrás una identificación, ingresa tu fecha de nacimiento y haz clic en el botón "Continuar".`,
      saving: "Guardar",
      talkExperts: "Hablar con los Expertos",
      welcomeMessage1:
        "Gracias por comunicarse con LifeSafer para asistirle, un socio de confianza en el que puede contar. Esta inscripción solo toma unos minutos y lo prepara para visitar uno de nuestros centros de servicio para una instalación rápida y sencilla.",
      yourAddress: " Tu Dirección ",
      yourAddressDescription:
        " Esto nos permite asignarle el centro de servicio más cercano y conveniente.",
      yourStateId: " Su Identificación Estatal",
      yourStateDescription:
        " Informar correctamente sobre su programa es una de nuestras principales prioridades, y todo comienza con información precisa.",
      yourAddressDescriptionLocation:
        "Su dirección de domicilio nos permite enviarle notificaciones oficiales, recordatorios y documentos importantes relacionados con los requisitos de su programa.",
      protectionMatters: "La Protección Importa",
      scheduleInstallationDescription:
        " Solo necesitamos un minuto más de su tiempo para programar su cita de instalación en línea. O bien, puede llamar a nuestro equipo de soporte dedicado, que responderá sus preguntas y lo ayudará a programar su cita.",
      accountSetup:
        " Acceda a su información en cualquier momento y desde cualquier lugar. El portal LifeSafer Mi Cuenta le brinda acceso completo. Por favor, cree su contraseña ahora.",
      selectServiceCenter: "Seleccione su Centro de Servicio",
      selectInstallationDate: "Seleccione su Fecha de Instalación",
      selectInstallationTime: " Seleccione su Hora de Instalación",
      myAccountSetUp: "Configurar Mi Cuenta",
      mobileLocation: "Ubicación Móvil",
      findLocations: "Buscar Ubicaciones ",
      findLocationsMessage:
        " La conveniencia importa: encuentre el centro de servicio más cercano.",
      findMyLocation: "Encontrar mi Ubicación",
      pricingInquiry: "Consulta de Precios",
      pricingInquiryMessage:
        " Obtenga rápidamente la cotización personalizada que busca.",
      getMyQuote: "Obtener mi Precio",
      learnMoreMessage:
        "Obtenga conocimientos sobre cómo LifeSafer puede ayudarle.",
      readySupport:
        " El equipo de soporte de LifeSafer está disponible 24/7 y cuenta con la experiencia y el conocimiento para asistirle con su inscripción",
      scheduleMessage:
        " Acceda directamente a la programación de su instalación con LifeSafer.",
      pickAStoryMessage1: "¿Cómo podemos ayudarle hoy?",
      scheduleToday: "Agenda Hoy",
      scheduleMessage1:
        "Programe la instalación de su dispositivo LifeSafer en solo unos minutos.",
      buildAQuote: "Crear una Cotización",
      buildAQuoteMessage: "Obtén tu cotización personalizada rápidamente.",

      findALocation: "Encontrar una Ubicación",
      findALocationMessage:
        "Encuentre un centro de servicio LifeSafer en su área.",
      isaInstallationBooked:
        "Tu cita para la instalación de ISA está programada para el {{appointmentDate}} a las {{appointmentTime}}",
      wrapUpDescription1:
        "Recibirás un mensaje de texto de confirmación con los detalles de tu instalación, junto con recordatorios previos a tu cita.",
      wrapUpDescription2:
        " Si tienes alguna pregunta mientras tanto, nuestros proveedores de servicio dedicados están aquí para ayudarte. Llámanos en cualquier momento al (833) 396-8034 para recibir asistencia.",
      wrapUpDescription2Mobile:
        "Si tienes alguna pregunta mientras tanto, nuestros proveedores de servicio dedicados están aquí para ayudarte. Llámanos al (833) 396-8034 a  {{anyTime}} para recibir asistencia.",
      thankYouIsa: "Gracias por elegir LifeSafer ISA.",

      lookForward:
        "Estamos ansiosos por colaborar contigo para proteger lo que más importa.",
      buildAQuoteReadyDescription:
        "Nuestro equipo está disponible ahora mismo para guiarte a través de todos los detalles. Llama o haz clic en el número que aparece abajo para hablar con tu especialista estatal.",
      buildAQuoteReadyTitle: "¡Tu cotización está lista para comenzar!",
      buildAQuoteReadyTitlePilot: "¡Tu cotización está en camino!",
      confirmDescription:
        "Realizaremos un pequeño cargo temporal para verificar tu tarjeta. Una vez confirmado, tu cuenta quedará configurada para pagos mensuales automáticos y seguros.",
      homeZip: "Código Postal",
      homePostal: "Código Postal",
      zipInvalid: "Código Postal no válido",
      postalCodevalidation: "Código Postal no válido",
      //newly added

      installationBooked: "¡Instalación Programada!",
      milesAway: "Millas de Distancia",
      lifeSaferLocation: "Encuentra una ubicación de LifeSafer cerca de ti",
      selectLocationTitle: "Selecciona una ubicación",
      selectLocationDescription:
        "Elige tu ubicación para que podamos darte la cotización más precisa.",
      zipOrCityState: "Código postal o ciudad, estado",
      enterZipOrCityState: "Ingresa el código postal o ciudad, estado.",
      googleMapsNotReady: "Google Maps aún no está listo.",
      noMatchingLocationFound: "No se encontró una ubicación coincidente.",
      unableToLoadLocation: "No se pudo cargar la ubicación.",
      savingYourLocation: "Guardando tu ubicación...",
      loading: "Cargando...",
      chooseThisDevice: "ELIGE ESTE DISPOSITIVO",
      quoteReady: "Exito! Tu cotizacion esta lista",
      quiteHourTitle1: "Gracias por solicitar tu cotizacion",
      quiteHourDes1:
        "Como tu solicitud llego fuera del horario permitido para llamadas, no podemos responder en este momento. Te contactaremos tan pronto como podamos, respetando las restricciones de contacto requeridas.",
      quiteHourDes2:
        "Si deseas ayuda ahora, nuestro equipo esta aqui y listo para ayudarte.",
      quiteHourButton1: "CONECTATE CON UN AGENTE AHORA",
      quiteHourButton2: "VER MI COTIZACION",
      quiteHourDes3:
        "Tu cotizacion esta lista para ver. Te enviaremos el enlace nuevamente por la manana para que te resulte mas facil.",
      quiteHourDes4:
        "Si deseas ayuda ahora, nuestro equipo esta aqui y listo para chatear.",
      quiteHourDes12:
        "Como tu solicitud llego fuera del horario permitido para mensajes de texto, no podemos responder en este momento. Te contactaremos tan pronto como podamos, respetando las restricciones de contacto requeridas.",
      quiteHourButton5: "CHATEA CON UN AGENTE AHORA",
      stateCityCountyRequired: "Estado, ciudad y condado son obligatorios",
      addressRequired: "{{addressRequired}}",
      generatingQuote: "Generando cotización",
      getExpertHelp: "Obtén ayuda de un experto",
      submit: "Enviar",
      quoteOnWayTextMessage:
        "Uno de nuestros Especialistas Estatales está preparando su cotización en este momento y se la enviará a su dispositivo móvil para que pueda acceder a ella de forma rápida y sencilla. Esté atento a un mensaje de texto nuestro para revisar pronto su información de precios personalizada.",
    },
    navigation: {
      returnTo: "Regresar a",
      lifesafer: "Lifesafer.com",
      assistMessage:
        "Deje que nuestro equipo de soporte, experto y capacitado, lo asista con esta inscripción",
    },
    toasts: {
      updateComplete: "Actualización Completa.",
      updateFailed: "La Actualización Falló.",
      deleteNotification: "Notificación eliminada.",
      messageDeleted: "Mensaje eliminado.",
      messageUpdated: "Mensaje actualizado.",
      messageCreated: "Mensaje creado.",
      error: "¡Se ha producido un error!",
      uploadComplete: "Subida finalizada.",
      uploadFailed: "Subida fallida.",
      saving: "Guardando.",
      textSent: "Mensaje de texto enviado.",
      textError: "Error al enviar mensaje de texto.",
      emailSent: "Correo electrónico enviado.",
      emailError: "Error al enviar el correo electrónico.",
      userCreated: "Usuario creado.",
      userCreationFailed: "Error al crear usuario. ",
      emailReset: "Correo electrónico restablecido exitosamente",
      duplicateData: "Se encontraron datos duplicados.",
      createComplete: "Crear completo.",
      createFailed: "Error al crear.",
      warning: "Actualice un campo antes de hacer clic en el botón Actualizar.",
      locationRequired: "La Ubicación es obligatoria",
      messageSent: "Mensaje enviado exitosamente",
      messageSentFailed: "Error al enviar el mensaje",
      emailSentSuccess: "Correo electrónico enviado correctamente",
      emailSentFailed: "Error al enviar el correo electrónico",
      refreshedSuccessfully: "Actualizado exitosamente",
      vehicleAdded: "Vehículo agregado exitosamente",
      codeSentSuccess: "Código de verificación enviado exitosamente",
      errorMessage: "Ha ocurrido un error, intentemoslo nuevamente.",
      noLocationPayment:
        "Esta ubicación no ha sido configurada para pagos en línea.",
      cardUpdatedMessage: "Tarjeta actualizada correctamente.",
      cardSuccessMessage: "Tarjeta añadida correctamente.",
    },
    speed: {
      selectAnswer: "Por favor seleccione una respuesta.",
      driverDescription:
        "Estas 3 preguntas rápidas nos ayudan a adaptar su programa ISA a las necesidades de su conductor.",
      allQuestionsIncomplete:
        "Seleccione una respuesta para las siguientes preguntas.",
      oneQuestionIncomplete:
        "Seleccione una respuesta para la pregunta {{questionNumber}}.",
      twoQuestionsIncomplete:
        "Seleccione una respuesta para las preguntas {{questionNumbers}}.",
      answerRequired: "Respuesta obligatoria",
      and: "y",
      introductionText1:
        "Cada vez que tu adolescente se pone al volante, la velocidad se convierte en un riesgo.",
      introductionText2:
        "¿Qué pasaría si pudieras reducir ese riesgo con <strong> <u>una sola decisión sencilla?</u> </strong>",
      introductionText3:
        "Presentamos <strong> LifeSafer Asistencia Inteligente de Velocidad (ISA),</strong> la elección sencilla para los padres que protege cada viaje.",
      introductionText4:
        "LifeSafer ISA mantiene a tu adolescente dentro de los límites de velocidad seguros, ayudando a reducir el riesgo desde el momento en que enciende el coche.",
      activeSpeedControl: "Control de Velocidad Activo",
      activeSpeedControlDescription:
        "LifeSafer ISA te mantiene dentro de los límites de velocidad establecidos utilizando control de velocidad activo, configuraciones de velocidad personalizadas y monitoreo GPS en tiempo real.",
      accelerationControl: "Control de Aceleración",
      accelerationControlDescription:
        "Prevén aceleraciones imprudentes tanto hacia adelante como en reversa. Nuestro dispositivo incluye funciones de limitación de RPM que suavizan los arranques rápidos y los cambios bruscos de velocidad.",
      tamperDetection: "Detección de Manipulación",
      tamperDetectionDescription:
        "Si el dispositivo se retira o se altera, se enviarán notificaciones de inmediato, manteniendo a todos informados y tu programa en marcha.",
      digitalDisplays: "Pantallas Digitales",
      digitalDisplaysDescription:
        "Consulta lo que importa de un vistazo con una pantalla digital en tiempo real que muestra tu velocidad actual, el límite de velocidad establecido y alertas codificadas por colores para los próximos cambios en el límite de velocidad.",
      temporaryOverride: "Anulación Temporal",
      temporaryOverrideDescription:
        "Para situaciones inesperadas, LifeSafer ISA incluye una función de anulación temporal que permite la desactivación momentánea del dispositivo. Tú estableces las reglas con límites personalizables de tiempo y uso.",
      pro: "Pro",
      realTimeSpeed: "Limitador de velocidad en tiempo real",
      realTimeSpeedDescription:
        "Evita que el vehículo exceda los límites de velocidad establecidos. A diferencia de los sistemas que solo emiten advertencias, esta función restringe activamente la velocidad en tiempo real.",
      configurableTopLimits: "Límites máximos configurables",
      accelerationReverseControl: "Control de aceleración y reversa",
      accelerationReverseControlDescription:
        "Restringe aceleraciones repentinas y maniobras inseguras en reversa, ayudando a reducir la probabilidad de conductas de conducción de alto riesgo.",
      goalTraining: "Entrenamiento orientado a objetivos",
      goalTrainingDescription:
        "Proporciona un marco para establecer objetivos de conducción medibles, apoyando el desarrollo de hábitos de conducción segura a lo largo del tiempo.",
      dedicatedCustomerService:
        "Servicio al cliente dedicado, 24/7, los 365 días del año",
      dedicatedCustomerServiceDescription:
        "El soporte está disponible en cualquier momento para asistencia con la instalación, solución de problemas o preguntas generales.",
      freeInstallation: "Instalación gratuita",
      configurabletTopSpeedLimit: "Límites de velocidad máxima configurables",
      configurabletTopSpeedLimitDescription:
        "Permite ajustar las velocidades máximas, los umbrales de alerta y el modo de operación (activo o pasivo). Las configuraciones se pueden actualizar a medida que el conductor adquiere experiencia.",
      driverReport: "Informe de calificación del conductor",
      driverReportDescription:
        "Proporciona resúmenes claros de la actividad de conducción, incluyendo patrones como exceso de velocidad, aceleración brusca y frenado fuerte, para ayudar a identificar áreas que puedan requerir mejora.",
      freeInstallationCost: "Instalación gratuita sin costo adicional",
      freeInstallationCostDescription:
        "La instalación profesional se realiza en un taller autorizado a tu cargo, y LifeSafer ofrece un crédito de $150 en tu cuenta para cubrir el costo en tu próxima factura.",
      priceLockGuarantee: "Garantía de precio fijo",
      priceLockGuaranteeDescription:
        "Disfruta de tranquilidad a largo plazo sabiendo que tu tarifa mensual de ISA está asegurada durante todo el plazo de 24 meses de tu plan. Se aplica a la tarifa base mensual vigente cobrada por LifeSafer. Excluye impuestos, cargos, recargos, complementos opcionales o descuentos. La garantía queda anulada si el servicio se cancela, suspende o se cambia a un plan no elegible. Los impuestos, cargos, recargos y servicios opcionales están sujetos a cambios.",
      priceLockGuaranteeDescription2:
        "Mantén tu presupuesto predecible con una tarifa mensual garantizada durante todo el plazo de 12 meses de tu plan. Se aplica a la tarifa base mensual vigente cobrada por LifeSafer. Excluye impuestos, cargos, recargos, complementos opcionales o descuentos. La garantía queda anulada si el servicio se cancela, suspende o se cambia a un plan no elegible. Los impuestos, cargos, recargos y servicios opcionales están sujetos a cambios.",
      priceLockGuaranteeDescription3:
        "Mantén la flexibilidad mientras aseguras tu tarifa mensual durante la duración de cada ciclo de facturación. Se aplica a la tarifa base mensual vigente cobrada por LifeSafer. Los impuestos, cargos y servicios opcionales pueden cambiar.",
      copilot: "Copiloto",
      billedMonthly1: "$99.99/mes, facturado mensualmente.",
      billedMonthly2: "$129.99/mes, facturado mensualmente.",
      billedMonthly3: "$190.99/mes, facturado mensualmente.",
      priceLockGuarantee1: "Garantía de precio fijo por 2 años",
      priceLockGuarantee2: "Garantía de precio fijo por 1 año",
      priceLockGuarantee3:
        "Cancela en cualquier momento, bajo tus propios términos.",
      kickstart: "Inicio rápido",

      //newly added
      howExperienced: "¿Qué tan experimentado es su conductor?",
      hasNotDriven: "No ha conducido aún",
      zeroto3: "0-3 meses",
      threeto6: "3-6 meses",
      sixto12: "6-12 meses",
      oneyearPlus: "1 año o más",

      whyInterested: "¿Por qué está interesado en un ISA?",
      developHabits: "Desarrollar buenos hábitos",
      ticketAccident: "Multa/Accidente",
      protection: "Protección",
      peaceOfMind: "Tranquilidad",
      other: "Otro",

      howSoon: "¿Cuándo le gustaría realizar la instalación?",
      asSoon: "Tan pronto como esté disponible",
      next30: "Próximos 30 días",
      thirtyto60: "30-60 días",
      sixtyplus: "Más de 60 días",
      undecided: "Indeciso",
      autoPaySignupTitle: "Registro para Pago Automático",
      readyDescription1:
        "Si tienes alguna pregunta mientras tanto, nuestros proveedores de servicio dedicados están aquí para ayudarte. Llámanos en cualquier momento al (833) 396-8034 para recibir asistencia.",

      learnMoreTitle: "Conduce Inteligente, Mantente Seguro",
      learnMoreMessage:
        "Descubre cómo ISA puede mejorar la seguridad vial de tu adolescente",
      hoverPicture:
        "Pasa el cursor sobre cada imagen para obtener más información",
      pricingTitle: "Elige tu Programa de Seguridad",
      close: "Cerrar",
      buildSafeTitle:
        "Fomenta Hábitos de Conducción Segura desde el Primer Día",
      buildSafeSubtitle:
        "Durante los primeros seis meses, los adolescentes están en mayor riesgo en la carretera.",
      passiveTitle: "Limitación Pasiva",
      activeTitle: "Limitación Activa",
      passivePoint1: "advierte al conductor",
      passivePoint2: "puede establecer una velocidad máxima",
      passivePoint3: "no detiene realmente el exceso de velocidad",
      activePoint1: "mantiene el auto dentro del límite de velocidad publicado",
      activePoint2: "previene el exceso de velocidad antes de que ocurra",
      paragraphInexperienced1:
        "Con la limitación de velocidad pasiva, un adolescente aún puede ignorar las alertas o desarrollar hábitos inseguros. Pero la limitación de velocidad activa, como LifeSafer ISA, elimina la tentación de exceder la velocidad y les ayuda a construir hábitos seguros desde el primer día, dándote tranquilidad real.",
      paragraphInexperienced2:
        "Para conductores nuevos, la Limitación de Velocidad Activa de LifeSafer ISA ofrece la protección más segura y constante.",
      paragraphExperienced1:
        "Con la limitación de velocidad pasiva, un adolescente aún puede ignorar las alertas o desarrollar hábitos inseguros. Pero la limitación de velocidad activa, como LifeSafer ISA, elimina la tentación de exceder la velocidad y les ayuda a reconstruir hábitos seguros.",
      paragraphExperienced2:
        "Para conductores nuevos, la Limitación de Velocidad Activa de LifeSafer ISA ofrece la protección más segura y constante.",
      howIsa: "Cómo ISA Refuerza Hábitos Seguros",
      enrollNow: "INSCRÍBETE AHORA",
      backTo: "VOLVER A",
      lifesaferISA: "LIFESAFERISA.COM",

      readyDescription1Mobile:
        "Si tienes alguna pregunta mientras tanto, nuestros proveedores de servicio dedicados están aquí para ayudarte. Llámanos al (833) 396-8034 en {{anyTime}} para asistencia.",
      readyDescription2:
        "Has dado un paso importante para mantener a tu adolescente seguro en la carretera. Nos mantendremos en contacto para que puedas dar el siguiente paso cuando sea el momento adecuado.",
      readyDescription3:
        "Programemos tu cita ahora. Instalar un dispositivo ISA en tu vehículo puede tomar tan solo una hora.",
      readyDescription4:
        "¿Necesitas más tiempo? Está bien también: puedes guardar tu información y programar cuando estés listo.",

      takeYourTime: "Todo Listo - Tómate Tu Tiempo",
      readyNextStep: "¿Listo para Dar el Siguiente Paso?",
      allSet: "¿Todo Listo?",
      scheduleLater: "Programar Más Tarde",
      saveScheduleLater: "Guardar y Programar Más Tarde",
      selectPlan: "SELECCIONAR ESTE PLAN",
      viewDetails: "VER DETALLES",

      driverTitle: "Experiencia del Conductor",
      Q: "P",

      reinforceSafeTitle:
        "Refuerza Hábitos Seguros a Medida que los Adolescentes Ganan Experiencia",
      reinforceSafeSubtitle:
        "Después de sus primeros seis meses de conducción, la confianza aumenta, pero también pueden aumentar los comportamientos de riesgo.",
      next: "Siguiente",
      tapPicture: "Toca cada imagen de abajo para aprender más",
      save: "GUARDAR",
    },
    payments: {
      acceptedPayMethods: "Métodos de Pago Aceptados",
      paymentMethod: "Método de Pago",
      endingIn: "Terminación en:",
      redoMessage: "Necesitarás volver a validar la información de la tarjeta.",
      zipCode: "Código Postal",
      cardNumber: "Número de Tarjeta",
      expDate: "Fecha de Expiración",
      autoPaySignUpMessage:
        "Al enviar la información de tu tarjeta de crédito o débito en esta página y marcar esta casilla, nos autorizas a cargar esta tarjeta conforme a los Términos y Condiciones de tu Acuerdo de Servicio del Programa.",
      autoPayEnroll: "Inscribirse en Pago Automático",
      zipCodeError: "Código Postal no válido, por favor corrige.",
      cardNumberError:
        "Número de tarjeta no válido, por favor inténtalo de nuevo.",
      cvv2Error: "CVV2 no válido, por favor corrige.",
      expDateError: "Fecha de expiración no válida, por favor corrige.",
      verifyButton: "Verificar",
      confirmation: "Confirmación",
      autoPayMessage:
        "Al marcar esta casilla, confirma con el cliente que está autorizando a LifeSafer a cargar esta tarjeta conforme a los Términos y Condiciones de su Acuerdo de Servicio del Programa.",
      ccVerificationError: "Hubo un problema al verificar este método de pago.",
      finishBooking: "Finalizar Reserva",
    },
    location: {
      device: "Dispositivo",
      programLength: "Duración del programa",
      stateInfo: "Información del estado",
      helpsState:
        "Esto ayuda a nuestros expertos a garantizar que completes tu programa de la forma más rápida y económica posible.",
      stateOpt1: "Me acojo al Plan de Protección contra Pérdidas de LifeSafer.",
      stateOpt2:
        "Renuncio al Plan de Protección contra Pérdidas de LifeSafer y reconozco que puedo ser responsable del costo del dispositivo en caso de daño.",
      welcomeLifesafer: "Bienvenido a LifeSafer",
      deviceSchedule:
        "Vamos a programar tu cita. Primero, ¿qué dispositivo necesitas?",
      chooseDeviceType: "Elige el tipo de dispositivo...",
      bookAppointment: "Reservar una cita",
      enterZipCode: "Ingresa el código postal",
      nolLocations: "No hay ubicaciones en el área seleccionada.",
      zipLabel: "Código postal o ciudad, estado",
      scheduleYourAppointment: "Programa tu cita",
      lifesaferShop: "Tu centro LifeSafer",
      scheduleLike: "¿Qué día te gustaría programar?",
      installationTime: "La instalación normalmente toma entre 60 y 90 minutos",
      moreDate: "Ver más fechas",
      availableAppointment: "Horarios de citas disponibles",
      whatIsThis: "¿Qué es esto?",
      lossProtectionTitle: "Plan de Protección contra Pérdidas de LifeSafer",
      lossProtectionDescription:
        "Reemplazar su dispositivo de monitoreo puede ser costoso. El Plan de Protección contra Pérdidas de LifeSafer le ahorra ese gasto y lo protege contra imprevistos. Le recomendamos encarecidamente que proteja su dispositivo.",
      exit: "Salir",
      county: "Condado",
      enrollmentCode: "Código de inscripción",
      enrollmentDescription1:
        "Los códigos de inscripción suelen ser proporcionados por socios, sistemas judiciales, agentes de libertad condicional y departamentos de vehículos motorizados.",
      enterCode:
        "Por favor, ingrese el código exactamente como aparece en su documento.",
      dontRememberEnrollment:
        "Si no recuerda su código de inscripción o no tiene uno, simplemente indique quién lo recomendó.",
      hearAboutHowLong:
        "Háganos saber cómo nos encontró. Ya sea a través de un motor de búsqueda, una recomendación de un abogado, redes sociales u otra fuente, su respuesta nos ayuda a mejorar la experiencia de nuestros clientes.",
      or: "O",
      hearAboutUs: "¿Dónde escuchó sobre nosotros?",
      hearAboutHow: "¿Cómo se enteró de nosotros?",
      chooseOne: "Elija uno...",
      whoReferred: "¿Quién o qué lo recomendó?",
      enterName: "Ingrese un nombre, organización o sitio web.",
      hearAboutNameRequired: "El nombre de referencia es obligatorio",
      submit: "Enviar",
      skip: "OMITIR",
      gotEnrollmentCode: "¿Tiene un código de inscripción?",
      state: "Estado",
      chooseState: "Elegir estado...",
      stateRequired: "El estado es obligatorio.",
      haveAnId:
        "¿No tiene su documento de identidad a mano en este momento? Seleccione el estado donde obtendrá su identificación, ingrese su fecha de nacimiento y haga clic en Continuar.",
      yourStateId: "Su identificación estatal",
      booked: "¡Su reserva está confirmada!",
      confirmationSent: "Recibirá la confirmación en breve.",
      at: "a las",
      youWillBeGoing: "Usted irá a",
      calendar: "Añadir al calendario",
      googleCalendar: "Google Calendar",
      appleCalendar: "Apple Calendar",
      outlookCalendar: "Outlook Calendar",
      createAccount: "Cree su cuenta de LifeSafer",
      scheduleMyAppointment: "Programar mi cita",
      finalConfirmationDescription:
        "Con una cuenta LifeSafer, puede ver fácilmente los detalles de sus citas, firmar documentos y administrar pagos, todo en un solo lugar. Cree su cuenta hoy y disfrute de una experiencia más rápida y eficiente.",
      addTo: "Agregar a",
      createPassword: "Crear una contraseña",
      confirmFinalPassword: "Confirmar contraseña",
      password: "Contraseña",
      createAccountBtn: "Crear una cuenta",
      iCalFile: "Archivo iCal",
      installDevice: "para instalar un {{deviceType}} en su",
      installDevicePAM: "para instalar un {{deviceType}}.",
      sessionExpired: "La sesión ha expirado",
      moreLocations: "MÁS UBICACIONES",
      moreTimes: "MÁS HORARIOS",
      trimLevel: "Nivel de versión",
      trimLevelPlaceholder: "Seleccione el nivel de versión",
      trimLevelRequired: "El nivel de versión es obligatorio",
      noAvailableDates:
        "Actualmente no hay fechas de citas disponibles para esta ubicación. Intente con otra ubicación o vuelva a intentarlo más tarde.",
      noAppointmentReserved: "La cita ya no está reservada",
      clickHere: "Haga clic aquí",
      restartAppointment: "para reiniciar su inscripción",
      appointmentReserved: "Cita reservada para",
      deviceUpdateMadeTitle: "Actualización de Dispositivo Realizada",
      deviceUpdateMadeDescription:
        "Parece que ha cambiado su dispositivo, lo que podría causar posibles problemas con la cita que seleccionó. Asegurémonos de que la fecha y hora de su cita sigan siendo adecuadas.",
      confirmAppointment: "CONFIRMAR CITA",
      cancel: "CANCELAR",
      pam: "PAM",
      noLocation: "No hay ubicaciones en el área seleccionada",
      openAfter: "Abierto después de las 5 p. m.",
      openWeekends: "Abierto los fines de semana",
      appointmentsToday: "Citas disponibles hoy",
      morning: "Mañana",
      afternoon: "Tarde",
      evening: "Noche",
      preferredShop: "UBICACIÓN PREFERIDA",
      lifesaferInstallationLoc: "Ubicaciones de instalación de LifeSafer",
      confirmPasswordValid: "Las contraseñas deben coincidir.",
      passwordRequired: "La contraseña es obligatoria.",
      confirmPasswordRequired: "La confirmación de contraseña es obligatoria.",
      passwordPattern:
        "La contraseña debe tener entre 8 y 24 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y un carácter especial.",
      courtOrdered: "Ordenado por el Tribunal",
      volunteer: "Voluntario",
      courtOrderedDescription:
        "Se me ha ordenado instalar un dispositivo de Asistencia Inteligente de Velocidad (ISA) en mi vehículo.",
      volunteerDescription:
        "Quiero instalar un dispositivo de Asistencia Inteligente de Velocidad (ISA) en el vehículo de mi hijo adolescente.",
      situation: "¿Cuál describe mejor su situación?",
      whatFeatures: "¿Qué características tiene su vehículo?",
      getStarted: "Comenzar",
      myShop: "Mi centro",
      setAsMyShop: "Establecer como mi centro",
      fleet: "Flota",
      fleetDescription:
        "Estoy interesado en la Asistencia Inteligente de Velocidad (ISA) para una flota de vehículos.",
      deviceTypeRequired: "El tipo de dispositivo es obligatorio",
      welcomeHeading: "Programa tu cita en {{serviceCenterName}}",
      welcomeTitleOne:
        "Programar tu cita de instalación solo toma unos 5 minutos.",
      welcomeTitleTwo: "De esto nos encargaremos:",
      welcomeTitleThree: "Confirmar tu configuración",
      welcomeDescriptionThree:
        "Detalles rápidos sobre ti, los requisitos de tu estado y tu vehículo (si es necesario)",
      welcomeDescriptionThreePam:
        "Detalles rápidos sobre ti y los requisitos de tu estado y tu vehículo (si es necesario)",
      welcomeTitleFourDescription:
        "Ayudarte a programar una cita en {{serviceCenterName}}",
      welcomeTitleFive: "Orientación integral",
      welcomeTitleFiveDescription:
        "Proporcionarte instrucciones claras sobre qué esperar a continuación",
      compliance: "Cumplimiento",
    },

    partner: {
      offenseState: "situación del delito",
      offenseStateRequired: "El estado de la infracción es obligatorio",
      offenseCounty: "Condado de la infracción",
      offenseCountyRequired: "El condado de la infracción es obligatorio",
      welcomeLifesafer: "Bienvenidos a LifeSafer",
      programDetails: "Detalles del programa",
      programDetailsDescription:
        "Esto nos ayuda a confirmar su elegibilidad y a asegurarnos de que todo esté configurado correctamente para su estado.",
      vehicleDescription:
        "Cuéntanos sobre tu vehículo para poder ofrecerte la mejor experiencia de instalación.",
      homeAddress: "Dirección de domicilio",
      homeAddressDescription:
        "Tu dirección de domicilio nos permite enviarte notificaciones oficiales, recordatorios y documentos importantes relacionados con los requisitos de tu programa.",
      stateDescription:
        "Reportar correctamente tu programa es una de nuestras principales prioridades, y comienza con información precisa.",
      inactivityScreenTitleOne: "Comenzar es fácil",
      inactivityScreenDescriptionOne:
        "Estás al inicio del proceso de inscripción, y te guiaremos en cada paso del camino.",
      inactivityScreenCardOne:
        "<strong>Cientos de miles de conductores</strong> han completado su programa con LifeSafer.",
      inactivityScreenCardTwo:
        "Con la confianza de socios en todo el país, nos enfocamos en <strong>expectativas claras, servicio confiable y menos sorpresas</strong> para que puedas avanzar con confianza.",
      inactivityScreenTitleTwo: "Estás avanzando muy bien",
      inactivityScreenDescriptionTwo:
        "Estás a mitad del proceso de inscripción — solo faltan unos pocos pasos más.",
      inactivityScreenCardThree:
        "Diseñado para ser <strong>compacto, claro</strong> y <strong>fácil de usar</strong> desde el primer día.",
      inactivityScreenCardFour:
        "Con un <strong>tamaño discreto</strong> y <strong>guía inteligente en pantalla</strong>, nuestro dispositivo te ayuda a <strong>mantenerte informado y evitar confusiones</strong> durante todo tu programa.",
      inactivityScreenTitleThree: "Ya casi terminas",
      inactivityScreenDescriptionThree:
        "Finaliza tu inscripción ahora para comenzar tu programa de bloqueo de encendido.",
      inactivityScreenCardFive:
        "Contamos con <strong>centros de servicio cercanos en {{matchedStateName}}</strong>, por lo que programar citas y el mantenimiento continuo se adapta <strong>fácilmente a tu rutina.</strong>",
      inactivityScreenCardSix:
        "Con LifeSafer, obtienes instalación de dispositivos de bloqueo de encendido <strong>sin largos desplazamientos ni disponibilidad limitada.</strong>",
      welcomeTitleOne:
        "Trabajamos directamente con {{partnerName}} para ayudarte a cumplir con el requisito de tu estado.",
      welcomeTitleTwo:
        "Como cliente referido, aceleraremos tu proceso de inscripción y nos aseguraremos de que tu configuración se gestione de manera fluida y sin complicaciones.",
      welcomeTitleThree: "Todo el proceso solo toma unos minutos.",
      welcomeTitleFour:
        "Todo el proceso solo toma unos minutos, y nos encargaremos de:",
      welcomeTitleFive: "De lo que nos encargamos:",
      referedToLifeSafer: "Referido a LifeSafer por {{partnerName}}",
      welcomeStepTitleOne: "Confirma tu configuración",
      welcomeStepDescriptionOne:
        "Detalles rápidos sobre ti, los requisitos de tu estado y tu vehículo (si es necesario)",
      welcomeStepDescriptionOnePam:
        "Detalles rápidos sobre ti y los requisitos de tu estado y tu vehículo (si es necesario)",
      welcomeStepTitleTwo: "Coordina la instalación",
      welcomeStepDescriptionTwo:
        "Programa una cita en una ubicación conveniente cerca de ti",
      welcomeStepTitleThree: "Gestiona los beneficios de tu referencia",
      welcomeStepDescriptionThree:
        "Aplica cualquier descuento y define claramente los próximos pasos",
      genericTrustedBanner:
        "Con la confianza de tribunales y agencias de supervisión en todo EE. UU.",
      genericWelcomeIntroOne:
        "Tribunales y agencias de supervisión de todo el país confían en LifeSafer para ayudar a los conductores a cumplir con los requisitos estatales con confianza.",
      genericWelcomeIntroTwo:
        "Te guiaremos durante la inscripción, la instalación y los reportes para ayudar a garantizar una experiencia fluida y conforme de principio a fin.",
      genericWelcomeTakeCareTitle: "De lo que nos encargaremos:",
      genericWelcomeStepDescriptionOne:
        "Detalles rápidos sobre ti, los requisitos de tu estado y tu vehículo (si es necesario)",
      genericWelcomeStepTitleThree: "Orientación integral",
      genericWelcomeStepDescriptionThree:
        "Desde la inscripción hasta la desinstalación, te acompañamos",
      offenseStateDescription:
        "Por favor, asegúrese de que este sea el estado en el que ocurrió la infracción. Este puede o no ser el mismo estado en el que usted vive.",
      continueEnrollment: "Continuar mi inscripción",
      partnerDescription:
        "Informar correctamente sobre su programa es una de nuestras principales prioridades, y comienza con información precisa.",
      inactivityScreenNote: "¿Cómo es el dispositivo Lifesafer?",
      aboutPartner:
        "Inicia tu inscripción y selecciona tu método de contacto preferido.",
      programDetailsPartnerDesp:
        "Esto nos ayuda a confirmar tu elegibilidad y a asegurarnos de que todo esté configurado correctamente según los requisitos de tu estado.",
      vehicleDescriptionPartner:
        "Cuéntanos sobre tu vehículo para que podamos brindarte la mejor experiencia de instalación.",
      addressDescriptionPartner:
        "Tu dirección residencial nos permite enviarte avisos oficiales, recordatorios y documentos importantes relacionados con los requisitos de tu programa.",
      idDescriptionPartner:
        "Reportar correctamente tu programa es una de nuestras principales prioridades, y todo comienza con información precisa.",
    },

    partnerPricing: {
      allSetTitle: "Todo listo",
      allSetDescriptionPartner:
        "{{partnerName}} te refirió aquí para que tengas una experiencia clara y predecible. Te mostraremos exactamente qué está incluido y qué esperar durante todo el programa. Sin cargos ocultos ni sorpresas.",
      allSetDescription:
        "Tu socio te remitió aquí para que tengas una experiencia clara y predecible. Te mostraremos exactamente qué está incluido y qué puedes esperar durante todo el programa. Sin cargos ocultos ni incertidumbre.",
      installationCostLabel: "Costo de instalación",
      programCostLabel: "Costo del programa",
      pricingOverviewTitle: "Resumen de precios",
      partnerReferralDiscountTitle: "Descuento por referencia del socio",
      partnerReferralDiscountDescription:
        "Ahorros aplicados gracias a tu referencia de {{partnerName}}. El crédito se aplica automáticamente a tu cuenta.",
      oneTimeInstallationCostTitle: "Costo único de instalación",
      oneTimeInstallationCostDescription:
        "Se paga directamente al centro de servicio como tarifa de mano de obra al momento de la instalación. LifeSafer no cobra tarifas adicionales de instalación.",
      programCostBiWeeklyTitle: "Costo del programa (cada 2 semanas)",
      programCostBiWeeklyDescription:
        "Renta del dispositivo, monitoreo y reportes requeridos.",
      questionsBeforeAppointment: "¿Preguntas antes de tu cita?",
      questionsHelpPrefix:
        "Estamos aquí para ayudarte. Llama o envíanos un mensaje al",
      questionsHelpSuffix: ", o chatea en cualquier momento.",
      scheduleAppointmentCta: "PROGRAMAR CITA",
      scheduleAppointmentTitle: "Programar cita",
      scheduleAppointmentDescription:
        "Elige la ubicación, la fecha y la hora de tu cita.",
      whatToExpectNextTitle: "Qué esperar después",
      attendAppointmentTitle: "Asiste a tu cita",
      attendAppointmentBullet1:
        "Lleva la documentación requerida a tu cita programada.",
      attendAppointmentBullet2:
        "Tu centro de servicio instalará el dispositivo y te explicará cómo funciona.",
      supportComplianceTitle: "Soporte continuo y cumplimiento",
      supportComplianceBullet1:
        "Después de la instalación, te apoyaremos con monitoreo, reportes estatales y recordatorios para que mantener el cumplimiento sea sencillo.",
      understandingPricingTitle: "Comprender los precios de su {{deviceType}}",
      yourPartnerDiscountTitle: "Tu descuento de socio",
      yourPartnerDiscountDescription:
        "Has recibido un crédito de socio de {{discountAmount}} por parte de {{partnerName}}, ya aplicado a los pagos de tu primer mes.",
      atInstallationTitle: "En la instalación",
      atInstallationDescription:
        "Un costo único de instalación pagado directamente a tu centro de servicio local durante tu cita.",
      programCostTitle: "Costo del programa",
      programCostDescriptionPrefix:
        "Un cargo recurrente por dispositivo y monitoreo que incluye:",
      programCostBullet1: "tu dispositivo {{deviceType}}",
      programCostBullet2: "reportes estatales requeridos",
      programCostBullet3: "monitoreo y soporte de cumplimiento",
      programCostBullet4: "calibración del dispositivo cuando aplique",
    },
  },
};
